export function escapeFileName(str: string): string {
    let outputStr = '';

    for (let i = 0; i < str.length; i += 1) {
        outputStr += `&#${str[i].charCodeAt(0)};`;
    }

    return outputStr;
}
